module.exports = __webpack_public_path__ + "static/img/ic_agc_mang.88b0a06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bdm/ic_agc_mang.png
// module id = us8+
// module chunks = 0